import { render, staticRenderFns } from "./LeaderColumn.vue?vue&type=template&id=0b387ff4&scoped=true"
import script from "./LeaderColumn.vue?vue&type=script&lang=js"
export * from "./LeaderColumn.vue?vue&type=script&lang=js"
import style0 from "./LeaderColumn.vue?vue&type=style&index=0&id=0b387ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b387ff4",
  null
  
)

export default component.exports